<template>
    <section class='hero is-theme is-fullheight'>
        <button class='button is-light howto-button' @click='showHelp'>
            <span class='icon'>
                <i class='far fa-question-circle'></i>
            </span>
            <span>使い方</span>
        </button>
        <button class='button is-light open-button' v-if="condition==='select'" @click="present">
            <span class='icon'>
                <i class="fas fa-user-friends"></i>
            </span>
            <span>結果発表</span>
        </button>
        <button class='button is-info is-rounded is-outlined urlButton' v-if="condition==='entry'|| condition==='select'" @click="copyUrl">
            <span class='icon'>
                <i class="far fa-copy"></i>
            </span>
            <span>URLをコピー</span>
        </button>
        <div class='hero-body'>
            <div class='container has-text-centered'>
                <div class='column is-6 is-offset-3'>
                    <div>
                        <span class='groupName'>{{groupName}}</span>
                    </div>
                    <!-- @は子→親で参照するメソッド -->
                    <Entry v-if='condition==="entry"' @alert='alert'/>
                    <Select v-if='condition==="select"' @alert='alert'/>
                    <Result v-if='condition==="result"' @alert='alert'/>
                </div>
            </div>
        </div>
        <div id='hidden'></div>
    </section>
</template>

<script>
// なぜか動かないのでここで読み込む
import { Toast } from 'buefy/dist/components/toast'
import Entry from '@/views/Page/Entry.vue'
import Select from '@/views/Page/Select.vue'
import Result from '@/views/Page/Result.vue'
import Help from '@/views/Page/Dialog/Help.vue'

export default {
    components: {Entry, Select, Result},
    data(){
        return{
            condition: '',
            groupName: '',
            db: this.$store.state.db,
            initialize: false,
            url: location.origin + location.pathname,
        }
    },
    watch:{
        condition:{
            // 後々参考にしたいので、oldValも記載しておく
            handler: (newVal, oldVal)=>localStorage.setItem('condition', newVal),
        }
    },
    mounted(){
        // 現在の状況を取得
        const loading = this.$loading.open({container: null});
        // resultから～
        this.$store.commit('setId', location.pathname.slice(1));
        // resultへの移行をウォッチ
        // 認証のタイミングでエラーがでることが多々ある
        this.resultCheck(loading);
    },
    methods:{
        resultCheck: function(loading){
                this.db.doc(this.$store.state.id).onSnapshot(snapShot=>{
                    if(!this.initialize){
                        this.fetchData(loading);
                    }
                    if(snapShot.data().done){
                        this.conditionManager("result");
                    }
                }, error=>{
                    console.log(error);
                    this.resultCheck(loading);
                });
        },
        fetchData: function(loading){
            this.db.doc(this.$store.state.id).get()
            .then(doc=>{
                this.initialize = true;
                // このへん変数にしたほうが良い
                this.groupName = doc.data().group;
                if(doc.data().done){
                    // resultから～
                    this.conditionManager("result");
                    loading.close(); 
                    return true;
                }
                // selectionから～
                if(localStorage.getItem(`${this.$store.state.id}-select`)){
                    this.conditionManager("select");
                    loading.close();
                    return true;
                }
                // entryから～
                this.conditionManager("entry");
                loading.close();
                return true;
            })
            .catch(error=>{
                console.log(error);
                this.alert(`エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`);
            })
        },
        alert: function(msg){
                this.$dialog.alert({
                    title: 'エラー',
                    message: msg,
                    type: 'is-danger',
                    hasIcon: true,
                    icon: 'times-circle',
                    iconPack: 'fa'
                });
        },
        showHelp: function(id, name){
            this.$modal.open({
                parent: this,
                component: Help,
            });
        },
        copyUrl: function(){
            let hidden = document.getElementById('hidden');
            hidden.insertAdjacentHTML('afterend', `<input type='text' id='url' value='${this.url}'>`);
            let url = document.getElementById('url');
            url.select();
            var range = document.createRange();
            range.selectNodeContents(url);
            var sel = window.getSelection();
            sel.removeAllRanges();
            sel.addRange(range);
            url.setSelectionRange(0, 999999);
            document.execCommand("copy");
            url.parentNode.removeChild(url);
            this.$toast.open({
                message: `URLをコピーしました。`,
                type: 'is-info'
            })
        },
        conditionManager: function(condition){
            let id = this.$store.state.id;
            let tmp = {};
            tmp[id] = {};
            switch(condition){
                case "entry":
                    this.condition = "entry";
                break;
                case "select":
                    this.$store.commit("setUid", localStorage.getItem(`${this.$store.state.id}-select`));
                    this.condition = "select";
                break;
                case "result":
                    this.$store.commit("setUid", localStorage.getItem(`${this.$store.state.id}-select`));
                    this.condition = "result";
                break;
            }
        },
        present: function(){
            this.$dialog.confirm({
                title: '開票',
                message: 
                    `グループ作成時のパスワードを入力してください。
                    <p class='control is-expanded'>
                        <input class='input' type='password' id='pw' placeholder='パスワード' maxlength='200'>
                    </p>`,
                cancelText: 'キャンセル',
                confirmText: '開票',
                type: 'is-info',
                onConfirm: ()=>this.checkPass(document.getElementById('pw').value)
            })
        },
        checkPass: function(pw){
            const loading = this.$loading.open({
                    container: null
                });
            this.db.doc(this.$store.state.id).get()
            .then(doc=>{
                let pass = doc.data().pass;
                if(pass !== pw){
                    this.alert("パスワードが一致しません。");
                    loading.close();
                    return false;
                }
                this.closingProcess(loading);
            })
            .catch(error=>{
                loading.close();
                console.log(error);
                this.alert(`エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`);
            })
        },
        closingProcess: function(loading){
            this.db.doc(this.$store.state.id).collection('name').get()
            .then(query=>{
                let allData = {};
                query.forEach(doc=>{
                    allData[doc.id] = doc.data();
                });
                // ランキング作成 
                this.ranking(allData, loading);
            })
            .catch(error=>{
                loading.close();
                console.log(error);
                this.alert(`エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`);
            })
        },
        ranking: function(all, loading){
            // ポイントづけ
            for(let key in all){
                let score = 0;
                let select1 = all[key].select1;
                let select2 = all[key].select2;
                let select3 = all[key].select3;
                if(all[key].select1)all[select1].score = all[select1].score + 1.5;
                if(all[key].select2)all[select2].score = all[select2].score + 1.3;
                if(all[key].select3)all[select3].score = all[select3].score + 1;
            }
            // ポイントのDB登録
            let len = Object.keys(all).length;
            let sentData = 0; 
            for(let key in all){
                this.db.doc(this.$store.state.id).collection('name').doc(key).set({
                    score: all[key].score
                },{merge: true})
                .then((doc)=>{
                    sentData++;
                    if(sentData === len){
                        this.match(loading);
                    }
                })
                .catch(error=>{
                    loading.close();
                    console.log(error);
                    this.alert(`エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`);
                })
            }
        },
        match: function(loading){
            this.db.doc(this.$store.state.id).collection('name').orderBy('score','desc').get()
            .then(query=>{
                let all = [];
                query.forEach(doc=>{
                    let tmp = {};
                    let data = doc.data();
                    tmp.id = doc.id;
                    tmp.select1 = data.select1;
                    tmp.select2 = data.select2;
                    tmp.select3 = data.select3;
                    tmp.match   = '';
                    all.push(tmp);
                });
                for(let i in all){
                    let tmp = all[i];
                    // すでにマッチしている人を飛ばす
                    if(tmp.match)continue;
                    let selection = [tmp.select1, tmp.select2, tmp.select3];
                    for(let j in all){
                        let tmp2 = all[j];
                        if(i === j || tmp2.match)continue;
                        let selection2 = [tmp2.select1, tmp2.select2, tmp2.select3];
                        // 両者にお互いIDがあれば成立
                        if(selection.includes(tmp2.id) && selection2.includes(tmp.id)){
                            tmp.match = tmp2.id;
                            tmp2.match = tmp.id;
                            break;
                        }
                    }
                }
                let len = 0;
                for(let i in all){
                    this.db.doc(this.$store.state.id).collection('name').doc(all[i].id).set({
                        match: all[i].match
                    }, {merge: true})
                    .then(()=>{
                        len++;
                        if(len === all.length){
                            this.closeGroup(loading);
                        }
                    })
                    .catch(error=>{
                        loading.close();
                        console.log(error);
                        this.alert(`エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`);
                    })
                }
            })
            .catch(error=>{
                loading.close();
                console.log(error);
                this.alert(`エラーが発生しました。<br>通信状況がいいところで再度試すか、<br>しばらくたってから再度試してください。`);
            })
        },
        closeGroup: function(loading){
            this.db.doc(this.$store.state.id).set({
                done: true,
            },{merge: true})
            .then(()=>{
                loading.close();
                this.conditionManager('result');
            })
            .catch(error=>{
                loading.close();
                this.alert(error);
                return false;
            });
        }
    }
}
</script>

<style scoped>
.open-button{
    position: absolute;
    top: 10px;
    right: 120px;
}
.groupName{
    font-size: 30px;
}
.urlButton{
    position: absolute;
    top: 10px;
    left: 10px;
}
.hidden{
    display: none;
}
</style>